<template>
  <div :class="$isFlag ? 'faceH5' : 'faceWeb'">
    <header-item
      :title-array="titleArray"
      :title-mb="titleArray[0]"
      :left-arrow="false"
    />
    <!-- 申诉成功提示 -->
    <div class="faceResult">
      <!-- <img src="~assets/images/accountCenter/success@2x.png" alt=""> -->
      <!-- <p>人脸认证已完成</p>
      <p>电脑端通过绑定身份证找回的用户请点击【认证已完成】</p> -->
      <p>请返回电脑端<br>点击【认证已完成】查看人脸识别结果</p>
    </div>
  </div>
</template>

<script>
import headerItem from '@/views/accountCenter/common/header'

export default {
  name: 'IdFaceTransfer',
  components: { headerItem },

  data() {
    return {
      titleArray: ['提示', '首页', '账号管理中心', '提示']
    }
  },
  created() {},
  mounted() {},
  methods: {}
}
</script>
<style lang="stylus">
@import '~assets/css/reset.styl';
</style>
<style lang="stylus" scoped>
// h5
.faceH5 {
  .faceResult {
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;

    img {
      display: block;
      margin-top: 1rem;
      height: 3rem;
    }

    p {
      margin: 0.5rem;
      font-size: 0.34rem;
      // color: #40BC40;
      line-height 1.75
      text-align: center
    }
  }
}

// web
.faceWeb {
  .headerWeb {
    font-size: 0.28rem;
    margin: 0.2rem 0.8rem;
    color: #4c4948;
    display: flex;
    justify-content: space-between;
    padding: 0.5rem 0 0.3rem 0;
    box-sizing: border-box;
    align-items: flex-end;
    border-bottom: #dedfdf 1px solid;

    .p1 {
      font-size: 0.4rem;

      span {
        display: inline-block;
        width: 0.1rem;
        height: 0.5rem;
        background: #606de2;
        vertical-align: sub;
        border-radius: 60px;
        margin-right: 0.15rem;
      }
    }

    .p2 {
      // font-weight: bold;
      color: #8b8686;
      font-size: 0.32rem;

      span {
        color: #616edf;
      }
    }
  }
}
</style>
